module.exports = __webpack_public_path__ + "img/6585ee60b7e6780ce837082e922f6cb9.png";